import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/learneryLogo2.svg'


const _withScopeId = n => (_pushScopeId("data-v-5367dedf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Learnery Logo",
    src: _imports_0
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, {
    dir: _ctx.direction,
    class: _normalizeClass({ 'rtl': _ctx.direction === 'rtl' })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay",
            side: _ctx.menuSide,
            disabled: _ctx.hideMenu
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "custom-scrollbar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPages.filter(ap=>!ap.hideMenu), (p, i) => {
                        return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                          "auto-hide": false,
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              onClick: ($event: any) => {_ctx.itemClicked(p);},
                              "router-direction": "root",
                              "router-link": p.url,
                              lines: p.line,
                              detail: false,
                              class: _normalizeClass(["hydrated", { selected: p.url === _ctx.router.currentRoute.value.path }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "router-link", "lines", "class"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "menu-item",
                            onClick: _ctx.logout
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.languageStore.language.menu.logout), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["side", "disabled"]), [
            [_vShow, !_ctx.pwaHide]
          ]),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["dir", "class"]))
}